export default __webpack_public_path__ + "static/media/hht1_ep20_timeline_q04_b.586edd2a.png";